import { render, staticRenderFns } from "./ReplaceVideoModal.vue?vue&type=template&id=b08286e8&scoped=true&"
import script from "./ReplaceVideoModal.vue?vue&type=script&lang=js&"
export * from "./ReplaceVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceVideoModal.vue?vue&type=style&index=0&id=b08286e8&prod&lang=scss&"
import style1 from "./ReplaceVideoModal.vue?vue&type=style&index=1&id=b08286e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08286e8",
  null
  
)

export default component.exports